import { Wand2, TrendingDown, Bot, type LucideIcon } from "lucide-react";
import Section, { SectionHeading } from "../ui/Section";
import { useApp } from "../../context/AppContext";
import { aiCards } from "../../data/content";

const iconMap: Record<string, LucideIcon> = { Wand2, TrendingDown, Bot };

export default function AppliedAI() {
  const { t, locale } = useApp();

  return (
    <Section id="ai">
      <div className="relative overflow-hidden rounded-[2rem] border border-soft bg-gradient-to-br from-cyan-500/[0.08] via-transparent to-purple-500/[0.08] p-6 sm:p-10">
        <div className="pointer-events-none absolute -right-20 -top-20 h-64 w-64 rounded-full bg-purple-500/20 blur-[100px]" />
        <SectionHeading tag={t("ai.tag")} title={t("ai.title")} subtitle={t("ai.subtitle")} />
        <div className="grid gap-5 sm:grid-cols-3">
          {aiCards.map((card) => {
            const Icon = iconMap[card.icon] ?? Bot;
            return (
              <div
                key={card.id}
                className="group rounded-2xl border border-soft card-bg p-6 transition-all duration-300 hover:-translate-y-1.5 hover:border-cyan-400/40"
              >
                <span className="mb-4 grid h-12 w-12 place-items-center rounded-2xl bg-gradient-to-br from-cyan-400 to-purple-500 text-slate-950 shadow-lg shadow-cyan-500/20 transition-transform group-hover:scale-110">
                  <Icon className="h-6 w-6" strokeWidth={1.8} />
                </span>
                <h3 className="font-display text-lg font-bold">{card.title[locale]}</h3>
                <p className="mt-2 text-sm leading-relaxed text-soft">{card.description[locale]}</p>
              </div>
            );
          })}
        </div>
      </div>
    </Section>
  );
}
